import { render, staticRenderFns } from "./notificationComponent.vue?vue&type=template&id=236a0034"
import script from "./notificationComponent.vue?vue&type=script&lang=js"
export * from "./notificationComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports